var ciudad = location.pathname;
if (ciudad == "/pages/barranquilla") {
  localStorage.setItem("ciudad", "Barranquilla");
  
} 

if (ciudad == "/pages/bogota") {
  localStorage.setItem("ciudad", "Bogota");
}

if (ciudad == "/pages/medellin") {
  localStorage.setItem("ciudad", "Medellin");
}

if (localStorage.getItem("ciudad") == "Barranquilla") {
 localStorage.setItem("ciudad", "NA");
  }


setTimeout(function () {
  
if (localStorage.getItem("ciudad") == "Medellin") {
  var elements = document.querySelectorAll(".InfoMedelin");
  elements.forEach(function (element) {
    element.style.display = "block";
  });

   var banners = document.querySelectorAll(".bannerCiudadesMedellin");
  banners.forEach(function (banner) {
    banner.style.display = "block";
  });

}
  }, 1000);



setTimeout(function () {
  
if (localStorage.getItem("ciudad") == "Barranquilla") {
  var elements = document.querySelectorAll(".tagCiudades");
  elements.forEach(function (element) {
    element.style.display = "block";
  });

   var banners = document.querySelectorAll(".bannerCiudadesBarranquilla");
  banners.forEach(function (banner) {
    banner.style.display = "block";
  });

}
  }, 1000);

setTimeout(function () {
if (localStorage.getItem("ciudad") == "Bogota") {
  
  var elements = document.querySelectorAll(".tagCiudades");
  elements.forEach(function (element) {
    element.style.display = "block";
  });

   var banners = document.querySelectorAll(".bannerCiudadesBogota");
  banners.forEach(function (banner) {
    banner.style.display = "block";
  });

   var ciudades = document.querySelectorAll(".envioCiudades");
  ciudades.forEach(function (ciudad) {
    ciudad.style.display = "none";
  });
  

}
  }, 1000);

console.log('ciudades');
console.log(localStorage.getItem("ciudad"));
